<template>
  <v-row no-gutters class="deltia-card ml-2 mr-2 mb-5 pl-6 pr-6 pt-6 pb-5">
    <!-- Otros datos de la mesa -->
    <v-col cols="12" md="12">
      <!-- Fila para las descripciones de los campos -->
      <v-row no-gutters class="hidden-sm-and-down">
        <!-- Nombre de la mesa -->
        <v-col md="10">
          <p class="font-weight-medium mb-1 text--disabled">
            Nombre
          </p>
        </v-col>
        <!-- Columna para la fecha -->
        <v-col md="2" :class="{ 'text-right': $vuetify.breakpoint.mdAndUp }">
          <p class="font-weight-medium mb-1 text--disabled">
            Agregado
          </p>
        </v-col>
      </v-row>
      <!-- Fila para los datos reales de la mesa -->
      <v-row no-gutters class="mb-5">
        <!-- Columna para el nombre de la mesa -->
        <v-col cols="12" md="10">
          <p class="font-weight-medium mb-1 text--disabled hidden-md-and-up">
            Nombre de la mesa
          </p>
          <p class="content--text font-weight-medium mb-0">
            {{ table.name }}
          </p>
        </v-col>
        <!-- Columna para la fecha -->
        <v-col
          cols="12"
          md="2"
          :class="{
            'text-right': $vuetify.breakpoint.mdAndUp,
            'hidden-sm-and-down': $vuetify.breakpoint.smAndDown
          }"
        >
          <p class="font-weight-medium mb-1 text--disabled hidden-md-and-up">
            Agregado
          </p>
          <p class="content--text font-weight-medium mb-0">
            {{ formatDate(table.created_at) }}
          </p>
        </v-col>
      </v-row>
    </v-col>
    <!-- Opciones -->
    <v-col cols="12" class="pt-0 mt-0">
      <v-row no-gutters>
        <!-- Fila para las descripciones de los campos -->
        <v-col cols="12" class="text-right">
          <p class="font-weight-medium mt-0 mb-1 text--disabled">
            Opciones
          </p>
        </v-col>
        <!-- Botón para eliminar la mesa -->
        <v-col cols="12" class="text-right">
          <!-- Menú para el botón de eliminar -->
          <v-menu top v-model="deleteMenu">
            <template v-slot:activator="{ on: deleteMenu }">
              <v-btn
                class="font-weight-bold"
                color="error"
                v-on="deleteMenu"
                icon
              >
                <v-icon>
                  mdi-trash-can-outline
                </v-icon>
              </v-btn>
            </template>
            <!-- Menú para eliminar la venta -->
            <v-list>
              <DeleteTable
                :tableId="table._id"
                @table-deleted="onTableDeleted"
                @table-error="onSaleError"
              />
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
// Importar mixins
import dateFormat from "@/mixins/dateFormat.js";

// Importar componentes
import DeleteTable from "@/components/tables/modals/DeleteTable";

export default {
  name: "TableItem",
  mixins: [dateFormat],
  props: {
    table: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      deleteMenu: false
    };
  },
  components: {
    DeleteTable
  },
  methods: {
    onSaleError: function(errorMessage) {
      this.$emit("table-error", errorMessage);
    },
    onTableDeleted: function() {
      this.$emit("table-deleted");
    }
  }
};
</script>

<style scoped>
.image-card {
  width: 100vw;
  height: 200px;
}
</style>
